var _style, _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 650 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: -3236.696,
    x2: -3236.696,
    y1: 198.616,
    y2: 364.9,
    gradientTransform: "rotate(180 -1471.263 249.945)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#f5f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341,
    stopColor: "#f5f3f5",
    stopOpacity: 0.939
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#f5f3f5",
    stopOpacity: 0.778
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#f5f3f5",
    stopOpacity: 0.518
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#f5f3f5",
    stopOpacity: 0.165
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M294.2 301.3c-45.9 0-83.1-37.2-83.1-83.1s37.2-83.1 83.1-83.1 83.1 37.2 83.1 83.1c0 45.8-37.2 83-83.1 83.1zm0-157.4c-41 0-74.3 33.3-74.3 74.3s33.3 74.3 74.3 74.3 74.3-33.3 74.3-74.3c-.1-41.1-33.3-74.3-74.3-74.3z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037673426463827103680000016841947038384734134_",
    x1: -3299.501,
    x2: -3309.007,
    y1: 230.608,
    y2: 221.102,
    gradientTransform: "rotate(180 -1471.26 249.932)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.148,
    stopColor: "#f5f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#f5f3f5",
    stopOpacity: 0.963
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#f5f3f5",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#f5f3f5",
    stopOpacity: 0.702
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.673,
    stopColor: "#f5f3f5",
    stopOpacity: 0.477
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#f5f3f5",
    stopOpacity: 0.194
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000037673426463827103680000016841947038384734134_)",
    d: "M353.9 272.4l6.2-6.3 9.5 9.5-6.2 6.3z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024695474791586684120000007699064869330361790_",
    x1: -3285.129,
    x2: -3295.33,
    y1: 217.589,
    y2: 207.389,
    gradientTransform: "rotate(-180 -1471.268 249.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.148,
    stopColor: "#f5f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#f5f3f5",
    stopOpacity: 0.963
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#f5f3f5",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#f5f3f5",
    stopOpacity: 0.702
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.673,
    stopColor: "#f5f3f5",
    stopOpacity: 0.477
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#f5f3f5",
    stopOpacity: 0.194
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000024695474791586684120000007699064869330361790_)",
    d: "M339.4 285.5l6.3-6.3 10.2 10.2-6.3 6.3z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000030456135654017223990000009659618433097900983_",
    x1: -8940.836,
    x2: -8940.836,
    y1: -5801.522,
    y2: -5894.996,
    gradientTransform: "rotate(134.999 -5551.631 -832.579)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.148,
    stopColor: "#f5f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#f5f3f5",
    stopOpacity: 0.776
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopColor: "#f5f3f5",
    stopOpacity: 0.363
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#f5f3f5",
    stopOpacity: 0.102
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000030456135654017223990000009659618433097900983_)",
    d: "M410 365l-66-66.1 28.9-28.9 66.1 66.1-6.3 6.3-59.8-59.9-16.4 16.4 59.8 59.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.9b6721e989c0f08d945ed141be1ed5d5.svg";
export { ForwardRef as ReactComponent };